<template>
    <PayoffOrderDetails v-model:open="sheetOpen" />
</template>

<script lang="ts" setup>
import PayoffOrderDetails from '@/components/Components/Payoff/PayoffOrderDetails.vue';
import type { PayoffOrder } from '@/interfaces/payoff/payoff-order.types';
import { BRIDGE_EVENT_EMITTER, BRIDGE_EVENTS } from '@/shared/constants/event-emitter';
import { usePayoffOrderStore } from '@/stores/company/payoff-order.store';
import type Emittery from 'emittery';
import { inject, ref } from 'vue';

/** This is a wrapper for the PayoffDetails component. It exists as an entry point
 * while we are using a vue sprinkle to instantiate a vue app in the old jquery code.
 * The handling of events from external code should live here to keep components down unaware of that.
 * It should be kept thin and not contain business logic and should be removed once
 * we have a proper SPA replacing the current file management page or equivalent
 */
const sheetOpen = ref(false);
const bridgeEventEmitter = inject<Emittery>(BRIDGE_EVENT_EMITTER);

const payoffOrderStore = usePayoffOrderStore();
bridgeEventEmitter?.on(BRIDGE_EVENTS.PAYOFF.CHANGE_CURRENT_PAYOFF, (data: { id: PayoffOrder['id'] }) => {
    if (data.id) {
        payoffOrderStore.currentPayoffId = data.id;
        sheetOpen.value = true;
    }
});
</script>
